import tailwindConfig from '@/../../tailwind.config';
import resolveConfig from 'tailwindcss/resolveConfig';
export const TAILWIND_CONFIG = resolveConfig(tailwindConfig);
export const CONFIG_BREAKPOINTS = (() => {
    const stringBreakpoints = TAILWIND_CONFIG.theme?.screens;
    const breakpointKeys = Object.keys(stringBreakpoints || {});
    const numericBreakpoints = {};
    for (const breakpointKey of breakpointKeys) {
        numericBreakpoints[breakpointKey] = parseInt(stringBreakpoints[breakpointKey], 10);
    }
    return numericBreakpoints;
})();
export const INITIAL_TAILWIND_CONTEXT = {
    config: TAILWIND_CONFIG,
    activeBreakpoints: null,
    numericBreakpoints: CONFIG_BREAKPOINTS,
    isDarkTheme: false
};
